import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Load files  ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "˃", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotifyError = _resolveComponent("NotifyError")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmitForm && _ctx.emitSubmitForm(...args)), ["prevent"])),
      class: _normalizeClass(_ctx.chosenMethod === 'creator' ? 'mt-5' : 'mt-10')
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(["nes-btn is-primary", { 'is-disabled': _ctx.isLoading }]),
        disabled: _ctx.isLoading,
        type: "submit"
      }, _hoisted_4, 10, _hoisted_1),
      _renderSlot(_ctx.$slots, "default")
    ], 34),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_NotifyError, {
          key: 0,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Uh oh something went wrong - " + _toDisplayString(_ctx.error), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}